export default "__VITE_ASSET__Ci9$wW4d__"